import { createStyles } from "@material-ui/core";

const styles = (theme: any) =>
  createStyles({
    pageHeading: {
      fontWeight: 600,
      fontSize: "1.5rem",
    },
    templateContainer: {
      marginTop: "10px",
      boxShadow: "0px 4px 18px rgba(0, 0, 0, 0.1)",
      borderRadius: "16px",
      backgroundColor: "#ffffff",
      padding: "32px",
    },
    accordionTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  });

export default styles;
